import { useSelector } from 'react-redux'
import { Table } from '../../../common/table/index'
import { valToPercent } from '../../../helpers/value'

const COLUMNS = {
  NAME: 'name',
  PERCENTAGE: 'percentage',
  COUNTRY: 'country',
}

export const CapitalOwnership = ({ data }) => {
  const locale = useSelector((state) => state.i18n.locale)

  const ids = data.map((_, index) => index)

  const getSchema = () => {
    return Object.keys(COLUMNS).map((key) => {
      const title = `alertDetail.${key}`
      const colId = COLUMNS[key]
      const parentThStyle = { backgroundColor: '#F3F3F3' }
      const thStyle = {
        backgroundColor: '#F3F3F3',
        justifyContent: colId === COLUMNS.PERCENTAGE ? 'flex-end' : '',
      }
      const tdStyle = ({ isHovered, isEvenRow }) => ({
        textAlign: colId === COLUMNS.PERCENTAGE ? 'right' : 'left',
        backgroundColor: isHovered
          ? '#EDF5FE'
          : isEvenRow
          ? '#F9F9F9'
          : '#F3F3F3',
      })

      return {
        colId,
        title,
        isI18n: true,
        parentThStyle,
        thStyle,
        tdStyle,
        render: (_, { rowIndex }) => {
          const value = data[rowIndex]?.[colId]
          switch (colId) {
            case COLUMNS.PERCENTAGE:
              return valToPercent(value, locale)
            default:
              return value
          }
        },
      }
    })
  }

  return <Table ids={ids} schema={getSchema()} autoHeightMax={600} />
}

CapitalOwnership.defaultProps = {
  data: [],
}
